module.exports = {
      id: "share-alt-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#share-alt",
      toString: function () {
        return this.url;
      }
    }